import * as React from "react";
import { cn } from "@/lib/utils";

// Status chip, copied from careers.co.jp's ui/badge.tsx (trimmed to the
// variants this site uses). Tinted background + on-color text, all from
// theme variables.

type Variant = "neutral" | "accent" | "ok" | "warn" | "danger";

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: Variant;
}

const styles: Record<Variant, string> = {
  neutral: "bg-surface-2 text-text",
  accent: "bg-brand-tint text-brand-on",
  ok: "bg-success-tint text-success-on",
  warn: "bg-warn-tint text-warn-on",
  danger: "bg-danger-tint text-danger-on",
};

export const Badge: React.FC<BadgeProps> = ({ variant = "neutral", className, ...props }) => (
  <span
    className={cn(
      "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[12px] font-semibold leading-snug",
      styles[variant],
      className,
    )}
    {...props}
  />
);
